export default function (url, params) {
  const csrfTokenMetaElement = window.document.querySelector('meta[name=csrf-token]')

  return window
    .fetch(url, {
      method: 'post',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfTokenMetaElement && csrfTokenMetaElement.content
      },
      body: JSON.stringify(params)
    })
    .then(response => response.json())
}
